import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import "../pages/Users/Users.css";

export default function Users() {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchUsers() {
            const res = await api.get("/users");
            setUsers(res.data);
        }
        fetchUsers();
    }, []);

    return (
        <div className="users-main">
            <div>
                <h1>Users</h1>
            </div>
            <div className="create-btn">
                <button
                    onClick={() => navigate("/users/create")}
                    className="px-3 py-1 bg-green-500 text-white rounded mb-4"
                >Create</button>
            </div>
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(u => (
                            <tr key={u.id}>
                                <td>{u.id}</td>
                                <td className="t-email">{u.email}</td>
                                <td className="t-role">{u.role}</td>
                                <td className="t-btn">
                                    <button
                                        //onClick={() => handleEdit(task)}
                                        className="edit-btn"
                                    >
                                        <i className="fas fa-edit"></i>
                                    </button>
                                </td>
                            </tr>))}
                    </tbody>
                </table>
            </div>

        </div>
    );
}
